import { __awaiter, __generator } from "tslib";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
// OnboardingLayout.tsx
import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import LayoutWrapperHOC from "../layout.wrapper.hoc";
import { getDashboardHeaderData } from "../../services/api/mange-trips/ManageTripsServices";
import useApiWrapper from "../../hooks/apiWrapper";
import { LayoutCodes } from "../../utils/enums/LayoutCodes";
import { useDispatch } from "react-redux";
import { setDashboardHeaderData } from "../../store/slices/manage-trips";
var ManageTripsLayout = function (_a) {
    var children = _a.children;
    var dispatch = useDispatch();
    var _b = useApiWrapper(function (response) { return dispatch(setDashboardHeaderData(response)); }), inProgress = _b.inProgress, apiWrapper = _b.apiWrapper;
    //dispatch(setLoading(true));
    var fetchNavHeaderData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    console.log("within fetchNavHeaderData");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    //dispatch(setLoading(true));
                    return [4 /*yield*/, apiWrapper(getDashboardHeaderData)];
                case 2:
                    //dispatch(setLoading(true));
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.log(error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        console.log("within use effect manage trips layout");
        fetchNavHeaderData();
        //homeToken();
    }, []);
    return (_jsx(_Fragment, { children: _jsx(Outlet, {}) }));
};
export default LayoutWrapperHOC(ManageTripsLayout, {
    layoutType: LayoutCodes.MANAGE_TRIPS,
});
